(function (mouseCursor, $) {
  "use strict";

  // This was adapted from https://codepen.io/farisk/pen/bMgrxy
  var cursorElement;
  //var movingTimer;
  var isScrollingTimer;
  var isCursorOnScreen = true;

  mouseCursor.init = function () {
    // This is generally complicated because some touch devices also have external mice e.g. some windows laptops, iPad pros

    // assume there is a mouse pointer initially, we are not sure at this moment
    _initialise.call(this);

    // Detect if the user is primarily using a mouse device
    var detectMouse = function (e) {
      if (e.type === "mousedown") {
        // We have confirmed it is a mouse (pointer) device
      } else if (e.type === "touchstart") {
        // It is a touch device, do not need to have a mouse cursor
        _deInitialise.call(this);
      }

      el.bodyElement.off("mousedown touchstart", detectMouse);
    };

    el.bodyElement.on("mousedown touchstart", detectMouse);
  };

  function _initialise() {
    cursorElement = $(".el-cursor");

    el.documentElement.on("WINDOW_SCROLL_EVENT.EL_MOUSE_CURSOR", handleScrollEvent);

    el.documentElement.on(
      "mouseenter.EL_MOUSE_CURSOR",
      "a, button, iframe, .el-cursor__magnifying-glass, .el-cursor__nav-right, .el-cursor__nav-left",
      cursorHover,
    );
    el.documentElement.on(
      "mouseleave.EL_MOUSE_CURSOR",
      "a, button, iframe, .el-cursor__magnifying-glass, .el-cursor__nav-right, .el-cursor__nav-left",
      cursorBlur,
    );
    el.documentElement.on("mousemove.EL_MOUSE_CURSOR", moveCursor);
    el.documentElement.on("mousedown.EL_MOUSE_CURSOR", cursorDown);
    el.documentElement.on("mouseup.EL_MOUSE_CURSOR", cursorUp);

    el.documentElement.on("mouseout.EL_MOUSE_CURSOR", function (e) {
      var from = e.relatedTarget || e.toElement;
      if (!from || from.nodeName === "HTML") {
        isCursorOnScreen = false;
        cursorElement.addClass("el-cursor--hidden");
      }
    });

    cursorElement.show();
  }

  function _deInitialise() {
    el.documentElement.off(".EL_MOUSE_CURSOR");
    cursorElement.hide();
  }

  function handleScrollEvent() {
    // Clear our timeout throughout the scroll
    window.clearTimeout(isScrollingTimer);

    if (!isScrollingTimer) {
      cursorElement.addClass("el-cursor--mouse-down");
    }

    // Set a timeout to run after scrolling ends
    isScrollingTimer = setTimeout(function () {
      cursorElement.removeClass("el-cursor--mouse-down");
      isScrollingTimer = false;
    }, 300);
  }

  function moveCursor(e) {
    if (!isCursorOnScreen) {
      isCursorOnScreen = true;
      cursorElement.removeClass("el-cursor--hidden");
    }

    cursorElement.css({ top: e.clientY, left: e.clientX });

    /*cursorElement.addClass('el-cursor--is-moving');
        clearTimeout(movingTimer);

        movingTimer = setTimeout(function() {
            cursorElement.removeClass('el-cursor--is-moving');
        }, 300);*/
  }

  function cursorHover(evt) {
    if (evt.target.classList.contains("el-cursor__magnifying-glass")) {
      cursorElement.addClass("el-cursor--magnifying-glass");
    } else if (evt.target.classList.contains("el-cursor__nav-left")) {
      cursorElement.addClass("el-cursor--arrow is-left");
    } else if (evt.target.classList.contains("el-cursor__nav-right")) {
      cursorElement.addClass("el-cursor--arrow is-right");
    } else if (evt.target.classList.contains("el-cursor__hide-cursor") /*|| evt.target.nodeName === "IFRAME"*/) {
      cursorElement.addClass("el-cursor--hidden");
    } else {
      cursorElement.addClass("el-cursor--is-hovering");
    }
  }

  function cursorBlur() {
    cursorElement.removeClass(
      "el-cursor--is-hovering el-cursor--magnifying-glass el-cursor--arrow is-right is-left el-cursor--hidden",
    );
  }

  function cursorDown() {
    cursorElement.addClass("el-cursor--mouse-down");
  }

  function cursorUp() {
    cursorElement.removeClass("el-cursor--mouse-down");
  }
})((el.MouseCursor = el.MouseCursor || {}), jQuery);
